<div class="enterprise-selector-container">
  Seleziona Azienda
  <nts-base-enum-text-box appendTo="body" [options$]="viewModel.enterpriseList$" [(value)]="viewModel.selectedEnterprise" (valueChange)="viewModel.onEnterpriseChange($event)"></nts-base-enum-text-box>

  Seleziona Ditta
  <nts-base-enum-text-box appendTo="body" [options$]="viewModel.filteredCompanyList$" [(value)]="viewModel.selectedCompany" (valueChange)="viewModel.onCompanyChange($event)"></nts-base-enum-text-box>
</div>